var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1612 5.03311C11.6135 5.03311 11.9802 4.64729 11.9802 4.17134C11.9802 3.6954 11.6135 3.30957 11.1612 3.30957C10.7089 3.30957 10.3422 3.6954 10.3422 4.17134C10.3422 4.64729 10.7089 5.03311 11.1612 5.03311Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.21249 7.85876C4.21249 9.83905 5.743 11.4495 7.62499 11.4495C9.50699 11.4495 11.0375 9.83905 11.0375 7.85876C11.0375 5.87848 9.50699 4.26807 7.62499 4.26807C5.743 4.26807 4.21249 5.87848 4.21249 7.85876ZM5.91874 7.85883C5.91874 6.86871 6.684 6.06348 7.62499 6.06348C8.56599 6.06348 9.33124 6.86871 9.33124 7.85883C9.33124 8.849 8.56599 9.65417 7.62499 9.65417C6.684 9.65417 5.91874 8.849 5.91874 7.85883Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.2125 15.0403H11.0375C12.7915 15.0403 14.45 13.2953 14.45 11.4496V4.26819C14.45 2.42261 12.7915 0.67749 11.0375 0.67749H4.2125C2.45848 0.67749 0.800003 2.42261 0.800003 4.26819V11.4496C0.800003 13.2953 2.45848 15.0403 4.2125 15.0403ZM2.50625 4.26819C2.50625 3.42889 3.41483 2.47284 4.2125 2.47284H11.0375C11.8352 2.47284 12.7438 3.42889 12.7438 4.26819V11.4496C12.7438 12.2889 11.8352 13.245 11.0375 13.245H4.2125C3.39947 13.245 2.50625 12.3051 2.50625 11.4496V4.26819Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.8694070030a30eaaab426a444e785c27.svg";
export { ForwardRef as ReactComponent };